module.exports = __webpack_public_path__ + "static/media/associate-degree.fa519323.png";